import { showMessage } from 'react-native-flash-message';

export type TonyteToastType = 'success' | 'error' | 'warning' | 'info';

// flash-message uses 'danger' instead of 'error'
const FM_TYPE: Record<TonyteToastType, 'success' | 'danger' | 'warning' | 'info'> = {
  success: 'success',
  error: 'danger',
  warning: 'warning',
  info: 'info',
};

const ACCENT: Record<TonyteToastType, string> = {
  success: '#26D0CE',
  error: '#ef4444',
  warning: '#F27D26',
  info: '#A18CD1',
};

export function showTonyteToast(message: string, type: TonyteToastType = 'info', description?: string) {
  const accent = ACCENT[type];
  showMessage({
    message,
    description,
    type: FM_TYPE[type],
    backgroundColor: '#0e1523',
    color: accent,
    style: {
      borderRadius: 16,
      marginHorizontal: 12,
      marginTop: 6,
      borderWidth: 1,
      borderColor: `${accent}40`,
    },
    titleStyle: {
      color: accent,
      fontWeight: '700',
      fontSize: 15,
    },
    textStyle: {
      color: 'rgba(255,255,255,0.62)',
      fontSize: 13,
    },
    duration: 3200,
    floating: true,
  });
}
